/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type EmailSignatureResponseTemplateKey = typeof EmailSignatureResponseTemplateKey[keyof typeof EmailSignatureResponseTemplateKey] | null;


export const EmailSignatureResponseTemplateKey = {
  sidebar: 'sidebar',
  stacked: 'stacked',
  banner: 'banner',
} as const;
